// extracted by mini-css-extract-plugin
export default {"import":"Privacy_import__XIYsU","importButton":"Privacy_importButton__39wht"};